module.exports = "<div class=\"ship-popup-wrapper\">\n  <lfwms-result-data-table [searchService]=\"lookupSearchService\">\n  </lfwms-result-data-table>\n</div>"


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.html
// module id = ../../../../../src/app/shared/lookup/gen-interface-rec-popup/gen-inter-rec-popup.component.html
// module chunks = main